import _ from 'lodash'
import React, { Fragment } from 'react'
import cn from 'classnames'
// import React, { useState } from 'react'
import { statusList, statusColors, statusWithDarkFont } from '../constants'
import { toggleInArray } from '../utils'

let StatusBtns = ({ shownStatuses, setShownStatuses, leads }) => {
  let allActive = statusList.length === shownStatuses.length
  let counts = _.countBy(leads, 'status')

  return !leads.length ? null : (
    <Fragment>
      <button
        className={cn('btn btn-sm', {
          'btn-secondary': allActive,
          'btn-outline-secondary border-0': !allActive,
        })}
        onClick={() => setShownStatuses(allActive ? [] : statusList)}
      >
        All <span className="badge">{leads.length}</span>
      </button>
      {_.map(statusList, status => {
        let active = _.includes(shownStatuses, status)
        let color = statusColors[status]

        return (
          <button
            key={status}
            className="btn btn-sm ml-2"
            onClick={() => {
              setShownStatuses(toggleInArray(shownStatuses, status))
            }}
            style={{
              color: active
                ? statusWithDarkFont[status]
                  ? undefined
                  : 'white'
                : color,
              backgroundColor: active ? color : undefined,
            }}
          >
            {_.startCase(status)}{' '}
            <span className="badge">{counts[status]}</span>
          </button>
        )
      })}
    </Fragment>
  )
}

export default StatusBtns
